/** @file quadHandlePoints: the screen points of a quad's eight resize handles and its pivot diamond. */
import type { QuadGeom } from './quadGeomOf';
import { QUAD_HANDLE_SPOTS } from './quadHandleSpots';
import { quadPoint } from './quadPoint';

/** Nine target-px points indexed by `QuadHandle`: the resize handles at `QUAD_HANDLE_SPOTS`, then the pivot. */
export function quadHandlePoints(g: QuadGeom): [number, number][] {
  return [...QUAD_HANDLE_SPOTS.map(([u, v]) => quadPoint(g.corners, u, v)), [g.pivot[0], g.pivot[1]]];
}
